import { NamedError } from "@core/utils/NamedError.js";

export class OrderUnpaidError extends NamedError {
	constructor() {
		super("Order hasn't been paid.");
	}
}
